import { css } from '@emotion/core';
import { tokens, applyFont, media } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var articleCard = /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;width:100%;border-radius:3px;overflow:hidden;min-height:124px;align-items:stretch;&:hover .title{color:", colors.neutral.heavy.hover, ";}");
export var link = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";text-decoration:none;");
export var content = {
  name: "o9jltu",
  styles: "display:flex;align-items:start;flex-grow:1;gap:16px;"
};
export var topImageContainer = {
  name: "1nq2tkm",
  styles: "display:block;height:200px;width:auto;img{width:100%;height:100%;object-fit:cover;}"
};
export var leftImageContainer = {
  name: "1o8d12p",
  styles: "display:block;width:250px;img{width:100%;min-width:250px;min-height:200px;object-fit:cover;max-height:206px;}"
};
export var tags = {
  name: "1hxaxql",
  styles: "display:flex;flex-wrap:wrap;overflow:hidden;align-self:flex-start;gap:4px;margin-top:8px;"
};
export var tag = /*#__PURE__*/css(applyFont(typography.mini), " margin:0;text-shadow:none;text-decoration:none;background-color:", colors.neutral.subdued.default, ";color:", colors.neutral.heavy.default, ";border-radius:100px;text-transform:none;padding:4px 8px;min-width:unset;&:hover{background-color:", colors.neutral.subdued.hover, ";color:", colors.neutral.heavy.hover, ";.tagLabel{background-color:", colors.neutral.subdued.hover, ";}}");
export var tagLabel = /*#__PURE__*/css(tag, " padding:0 1px;");
export var middle = /*#__PURE__*/css("display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;gap:8px;", media('<tablet'), "{margin-top:8px;}");
export var heading = /*#__PURE__*/css(applyFont(typography.subheading), " ", truncateLines(2), " ", media('>=tablet'), "{", applyFont(typography.displaySmall), "}");
export var authorDate = /*#__PURE__*/css("display:flex;flex-direction:row;color:", colors.neutral.medium.default, ";gap:8px;");
export var author = /*#__PURE__*/css(applyFont(typography.captionBold), " border-right:1px solid ", colors.neutral.trim.default, ";padding-right:8px;");
export var date = /*#__PURE__*/css(applyFont(typography.caption));